import React from 'react';
import { Checkbox } from '@carbon/react';

export default function CheckboxControl(props) {
  return <Checkbox {...props} />;
}
